'use client'
// Partage, dans l'onglet, de la liste des organisations déjà lue par la page /admin/organisations : le panneau de contrôle
// (panneau IA, à droite) l'affiche sans refaire la requête. Chaque lecture de GET /platform/organizations est tracée au journal
// de la plateforme — la doubler à chaque page ferait deux lignes d'audit pour une seule consultation.
import { useEffect, useState } from 'react'

export interface PlatformOrg {
  id: string; name: string; slug: string; status: 'ACTIVE' | 'SUSPENDED' | string
  websiteUrl: string | null; hasLogo: boolean; logoVersion: number | null; operator: boolean
  memberships: { active: number; suspended: number; revoked: number }
  /** null = source de présence indisponible (jamais « 0 en ligne »). */
  presence: { online: number; offline: number } | null
}

const EVENT = 'ab-platform-orgs'
let current: PlatformOrg[] | null = null

export function publishPlatformOrgs(list: PlatformOrg[] | null): void {
  current = list
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(EVENT))
}

export function usePlatformOrgs(): PlatformOrg[] | null {
  const [list, setList] = useState<PlatformOrg[] | null>(current)
  useEffect(() => {
    const on = () => setList(current)
    window.addEventListener(EVENT, on); on()
    return () => window.removeEventListener(EVENT, on)
  }, [])
  return list
}
